// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_BuscapaisesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for buscaPaises() /localidades/buscaPaises
 *
 * Proxy to locations-service (Go microservice). Each row mirrors
 * `entity.Country` from services/locations-service/src/localidades/country/entity/entity.go.
 */
import type { Localidades_BuscapaisesRow } from './Localidades_BuscapaisesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Localidades_BuscapaisesResponseDados = Localidades_BuscapaisesRow[];

export type Localidades_BuscapaisesResponse = ApiResponse<Localidades_BuscapaisesResponseDados>;

registerResponseContract('Localidades_BuscapaisesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:     { type: 'number',  required: false },
      Name:   { type: 'string',  required: false },
      Code:   { type: 'string',  required: false },
      States: {
        type: 'array',
        required: false,
        items: {
          ID:        { type: 'number',  required: false },
          Name:      { type: 'string',  required: false },
          UF:        { type: 'string',  required: false },
          CountryID: { type: 'number',  required: false },
          Cities: {
            type: 'array',
            required: false,
            items: {
              ID:      { type: 'number',  required: false },
              Name:    { type: 'string',  required: false },
              StateID: { type: 'number',  required: false },
            },
          },
        },
      },
    },
  },
})
